<template>
  <transition name="fade">
    <div
      v-show="visible"
      class="pop-body-loading"
    >
      <div class="fl spinner1">
        <div class="double-bounce1" />
        <div class="double-bounce2" />
      </div>
    </div>
  </transition>
</template>
<script>
export default {
    name: "Loading",
    props: {
        visible:{
            type: Boolean,
            default :false,
        },
    },
    data () {
        return {
        };
    },
    computed: {
            
    },
    created() {
            
    },
    methods:{
        clickClosePop() {
                
        },
    },
};
</script>
<style lang="stylus" scoped>
@require "~@/assets/css/public/trans.styl"
.pop-body-loading{
    position: fixed;left: 0;top: 0;width: 100%;height: 100%;background: rgba(0,0,0,.3);z-index: 100;
}
.fade-enter-active, .fade-leave-active {
  transition: opacity .5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.spinner1 {
    width: trans(80);
    height: trans(80);
    position: relative;
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    -webkit-transform: translate(-50%, -50%);
}
.double-bounce1, .double-bounce2 {
    width: 100%;
    height: 100%;
    border-radius: 50%;
    background-color: #fff;
    opacity: 0.6;
    position: absolute;
    top: 0;
    left: 0;
    -webkit-animation: bounce 2.0s infinite ease-in-out;
    animation: bounce 2.0s infinite ease-in-out;
}
.double-bounce2 {
    -webkit-animation-delay: -1.0s;
    animation-delay: -1.0s;
}
@-webkit-keyframes bounce {
  0%, 100% { -webkit-transform: scale(0.0) }
  50% { -webkit-transform: scale(1.0) }
}

@keyframes bounce {
  0%, 100% { 
    transform: scale(0.0);
    -webkit-transform: scale(0.0);
  } 50% { 
    transform: scale(1.0);
    -webkit-transform: scale(1.0);
  }
}
</style>



// WEBPACK FOOTER //
// src/components/native/pay/comp/Loading.vue